// extracted by mini-css-extract-plugin
export default {"wrapper":"HighlightFeatureModal__wrapper--P27cX"};